module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_coupon_pc2-58a86c30e44c355165211b16fbea0a60.svg";